module.exports = __webpack_public_path__ + "static/media/third-font.85e70dec.svg";